import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export function useEmitAssetSidebarResizeEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (sidebarSize: number | undefined) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.AssetSidebarResize,
        customTrackingFields: {
          sidebar_size_percent: sidebarSize || 0,
        },
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
